import { useEffect, useRef, useState } from "react";

import { IoIosArrowDroprightCircle } from "react-icons/io";
import { IoIosArrowDropleftCircle } from "react-icons/io";
import { getApiCall } from "../../utils/services";
import { Link, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import LazyImage from "../image/LazyImage";

// Register the modules

// Import Swiper styles


const CommonSlider = ({ brandimg, brand }) => {
  const location = useLocation();
  const { pathname } = location;
  const [isSmallScreen, setSmallScreen] = useState(false);

  const [images, setImages] = useState([]);
  const [allImages, setAllImages] = useState({})
  const swiperRef = useRef(null);

  // Function to go to the previous slide
  const goToPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  // Function to go to the next slide
  const goToNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const settings = {
    slidesPerView: 1,
    loop: true,
    pagination: {
      clickable: true,
    },
    autoplay: {
      delay: 3000, // Delay between slides in milliseconds
      disableOnInteraction: false, // Keep autoplay running even after interaction
    },
    modules: [Autoplay, Navigation, Pagination], // Register the modules
  };
  useEffect(() => {
    getApiCall(
      "user/bannersApi",
      (resp) => {
        if (resp) {
          setAllImages(resp);


        }


      },
      (error) => {

      }
    );
  }, [pathname]);


  

  useEffect(() => {
    const handleResize = () => {
      setSmallScreen(window.innerWidth < 768);
    };

    // Initial check on component mount
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  useEffect(() => {
    const { banners={}, mobileBanners={} } = allImages;
    const bannersValid =Object.values(banners).every(elm=>elm?.length>0)
    const mobileBannersValid =Object.values(mobileBanners).every(elm=>elm?.length>0)

    if(bannersValid&&mobileBannersValid){
      if (pathname === "/") {
        setImages(isSmallScreen ? mobileBanners?.homepage : banners?.homepage);
      } else {
        setImages(isSmallScreen ? mobileBanners?.[brand] : banners?.[brand]);
      }
    }

  
  }, [pathname, isSmallScreen, allImages, brand]);
  
  return (
    <>
      <Swiper ref={swiperRef} {...settings}>
        {images?.length > 0 ? images?.map((image, index) => (
          <SwiperSlide key={index} className="w-full h-full">
            <Link to={`/${image.value}`} className="h-full w-full">

              <LazyImage
                src={image?.image_link}
                // src={image}
                style={{aspectRatio:"auto 4000 / 1400",}}
                alt={`Slide ${index}`}
                decoding="async"


                className={` aspect-1360/1652 w-full  md:aspect-4000/1400 object-cover`}
                 />

            </Link>
          </SwiperSlide>
        )) : 
          <SwiperSlide  className="w-full h-full">
           <div
          className={"h-[450px] lg:h-[530px] xl:h-[600px] 2x:h-[630px] aspect-pulse bg-gray-300   xl:object-center w-full box-border border-none"} >
        </div>
          </SwiperSlide>
        }
      </Swiper>

      {/* Custom Navigation Buttons */}
      <div className="hidden md:flex  arrow-containerbrand">
        <button
          className="text-2xl md:text-3xl absolute top-1/2 left-1 z-[8] transform -translate-y-1/2"
          onClick={goToPrev}
        >
          <IoIosArrowDropleftCircle className="text-gray-500" />
        </button>
        <button
          className="text-2xl md:text-3xl absolute top-1/2 right-1 z-[8] transform -translate-y-1/2"
          onClick={goToNext}
        >
          <IoIosArrowDroprightCircle className="text-gray-500" />
        </button>
      </div>
    </>
  );
};

export default CommonSlider;
